<script>
import BrokerageConsoleLayout from '@layouts/brokerage-console-main'
import BrokerageBalanceList from '@components/brokerage-console/balance-list'

export default {
  page: {
    title: 'BrokerageConsole::BalanceList',
    meta: [{ name: 'description', content: 'BrokerageConsole::BalanceList' }],
  },
  components: { BrokerageConsoleLayout, BrokerageBalanceList },
}
</script>

<template>
  <BrokerageConsoleLayout>
    <BrokerageBalanceList></BrokerageBalanceList>
  </BrokerageConsoleLayout>
</template>
